module.exports = __webpack_public_path__ + "static/media/visitorphoto.30d9935a.png";